import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class AccountingAssetActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/Asset/AssetBrowser")
	}

	render() {
		return (
			<Activity 
				name="Asset"
				RenderedComponent={this.RenderedComponent}
				context="Asset"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(AccountingAssetActivity)
